module.exports = __webpack_public_path__ + "static/img/lodgingBackImg.1c07d50f.png";